// Replace / Remove for the uploaded measurement report (QA #18: only Replace existed).
interface ReportActionsProps {
  hasReport: boolean;
  readOnly: boolean;
  /** A Generate Summary run is in flight — the server refuses changes, so the buttons say so. */
  locked: boolean;
  removing: boolean;
  onReplace: () => void;
  onRemove: () => void;
}

const linkCls = 'text-xs font-semibold text-accent-text hover:underline disabled:cursor-not-allowed disabled:opacity-50 disabled:no-underline';

export function ReportActions({ hasReport, readOnly, locked, removing, onReplace, onRemove }: ReportActionsProps) {
  if (!hasReport || readOnly) return null;
  return (
    <div className="flex items-center gap-3">
      <button type="button" disabled={locked} onClick={onReplace} className={linkCls}>
        + Replace
      </button>
      <button type="button" disabled={locked || removing} onClick={onRemove} className={linkCls}>
        {removing ? 'Removing…' : 'Remove'}
      </button>
    </div>
  );
}

export default ReportActions;
